module.exports = __webpack_public_path__ + "static/img/bg-ar.9b6ab254.webp";